import React, { useEffect } from 'react';
import { Row, Card } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { Colxx } from 'components/custom/CustomBootstrap';
import IntlMessages from './helpers/IntlMessages';

 
const Error = () => {
  useEffect(() => {
    document.body.classList.add('background');
    document.body.classList.add('no-footer');

    return () => {
      document.body.classList.remove('background');
      document.body.classList.remove('no-footer');
    };
  }, []);

  return (
    <>
      <div className="fixed-background" />
      <main>
        <div className="container">
          <Row className="h-100">
            <Colxx xxs="12" md="10" className="mx-auto my-auto">
              <Card className="auth-card">
                <div className="position-relative image-side "></div>
                <div className="form-side">
                  <NavLink to="/" className="white">
                    <span className="logo-single" />
                  </NavLink>
                  <Card.Body>
                    <Card.Title className="mb-4">
                      <IntlMessages id="error.error-title" />
                    </Card.Title>
                    <p className="mb-0 text-muted text-small mb-0">
                      <IntlMessages id="error.error-code" />
                    </p>
                    <p className="display-1 font-weight-bold mb-5">404</p>
                    <NavLink to={'/'} className="btn btn-primary btn-shadow btn-lg">
                      <IntlMessages id="pages.go-back-home" />
                    </NavLink>
                  </Card.Body>
                </div>
              </Card>
            </Colxx>
          </Row>
        </div>
      </main>
    </>
  );
};

export default Error;
